import { render, staticRenderFns } from "./TraxTrainingCourseEditTopBox.vue?vue&type=template&id=47393e15"
import script from "./TraxTrainingCourseEditTopBox.vue?vue&type=script&lang=js"
export * from "./TraxTrainingCourseEditTopBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports